import { AttachedObjectResponse } from "@/Common/Models/FileSelection/Responses/AttachedObject";
import { FileType } from "@/Common/Models/FileType";
import { SignedPrintAuthorization } from "@/Common/Models/SignedPrintAuthorization";

class ExportableFileResponse {
    public Id: string;
    public Type: FileType;
    public Description: string;
    public Date: string;
    public LastSignature: SignedPrintAuthorization;
    public IsExternal: boolean;
    public ClientTag: string;
    public ClaimId: string;

    public constructor(init?: Partial<ExportableFileResponse>) {
        Object.assign(this, init);
    }

    public static fromFileSelectionResponse(model: ExportableFileResponse): AttachedObjectResponse {
        return new AttachedObjectResponse({
            ObjectId: model.Id,
            Type: model.Type,
            Description: model.Description,
            AssociatedSignedPrintAuthorization: model.LastSignature
        });
    }
}

export { ExportableFileResponse };
